import { Router } from '@angular/router';
import { CommonService } from './../../../@core/customs/common.service';
import { AuthService } from './../../../@core/auth.service';
import { Component, OnInit } from '@angular/core';
import { SUCCESS_RESPONE } from '../../../@core/customs/constants';
import { environment } from '../../../../environments/environment';
import { TokenService } from '../../../@core/token.service';

@Component({
  selector: 'ngx-login-layout',
  styleUrls: ['login-layout.component.scss'],
  templateUrl: './login-layout.component.html',
})
export class LoginLayoutComponent implements OnInit {

  user: {
    username: string,
    password: string,
    dinhDanhApp: string
  };

  lstApplication: any[] = [];
  path: string = environment.APP_SONONGNGHIEP_PATH;

  constructor(
    private router: Router,
    private authService: AuthService,
    private commonService: CommonService,
    private tokenService: TokenService
) { }
  ngOnInit() {
    if (!this.authService.checkTokenExpired() && !this.isUserEmpty()) {
      this.router.navigate(['/sonongnnghiep/admin/bao-cao-san-luong']);
    }
    this.user = {
      username: null,
      password: null,
      dinhDanhApp: 'APPNONGNGHIEP',
    };

    this.authService.getListApplication().subscribe(result => {
      if (result.code === SUCCESS_RESPONE) {
        this.lstApplication = result.data;
      }
    });
  }

  async isUserEmpty() {
    await this.tokenService.getUserInfo().subscribe((users: any) => {
      if (this.user === null || this.user === undefined) {
        return true;
      }
    });
    return false;
  }

  loginSSO() {

  }

  login() {
    const appSelect = this.lstApplication?.find(c => c.dinhdanhapp === this.user.dinhDanhApp) ?? null;
    this.authService.login(this.user, appSelect.state).subscribe(() => {},
    error => {
      this.commonService.toastrDanger('Đăng nhập thất bại: ' + error);
    }
    );
  }

  createUser() {

  }
}
